import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import Spinner from "react-activity/dist/Spinner";
import tanuragalogo from "../assets/images/tanuraga-logo.png";
import { apiUrl } from '../config/Config';

const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  const [email, setemail] = useState("");
  const [showloding, setshowloding] = useState(false);

  const handleSubmit = async(e) => {
    e.preventDefault();

    if (!email) {
      Swal.fire({
        title: '',
        text: 'Email is required',
        icon: 'error',
        width: '350px',
        confirmButtonText: 'Ok',
        confirmButtonColor: "rgb(59, 151, 196)",
        customClass: {
          popup: "small-icon-alert",
        },
      });
      return;
    }

    setshowloding(true);
    const headers = {
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      }
    };

    await axios.post(apiUrl + 'customergenerateotp', { email }, headers).then((res) => {
      if(res.data.status === 'success') {
        sessionStorage.setItem('passwordResetEmail', email);
        Swal.fire({
          title: '',
          text: res.data.message,
          icon: 'success',
          width: '350px',
          confirmButtonText: 'Ok',
          confirmButtonColor: "rgb(59, 151, 196)",
          customClass: {
            popup: "small-icon-alert",
          },
        });
        navigate('/submit-otp', { state: { email } });
      } else {
        Swal.fire({
          title: '',
          text: res.data.message,
          icon: 'error',
          width: '350px',
          confirmButtonText: 'Ok',
          confirmButtonColor: "rgb(59, 151, 196)",
          customClass: {
            popup: "small-icon-alert",
          },
        });
      }
    }).catch((err) => {
      alert(err.message);
    });
    setshowloding(false);
  };

  return (
    <div className="register-page-container">
      <div className="register-page-card">
        <div className="register-page-header">
          <h2 className="register-page-logo">
            <img src={tanuragalogo} className='loginpagelogo' alt="Tanuraga Logo" />
          </h2>
          <p className="register-page-tagline">Forgot Password</p>
        </div>

        <form className="login-page-form" onSubmit={handleSubmit}>
          <div className="register-page-form-group">
            <label htmlFor="email" className="register-page-label">Email</label>
            <input
              type="email"
              id="email"
              className="register-page-input"
              placeholder="Enter your registered email"
              value={email}
              onChange={(t) => setemail(t.target.value)}
              required
            />
          </div>

          <button type="submit" className="register-page-button">
            {
              showloding ?
              <Spinner color='#fff' size={15} className='spinnerCenter' /> :
              "Send OTP"
            }
          </button>
        </form>

        <p className="register-page-separator">Or</p>
        <p className="register-page-footer">
          Remember your password? <Link to={'/login'} className="register-page-link">Login</Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
